import { useAuth0 } from "@auth0/auth0-react";
import { useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { useInvoicesQuery } from "~/graphql/graphql-new.gen";
import type { InvoiceCreatedSubscription } from "~/graphql/graphql.gen";
import { InvoiceCreatedDocument } from "~/graphql/graphql.gen";

import { activeSaleState } from "../stores/sales";
import { getSubscriptionClient } from "./subscription-client";

export const useInvoiceCreatedSubscription = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const activeSale = useAtomValue(activeSaleState);

  useEffect(() => {
    const client = getSubscriptionClient(getAccessTokenSilently);
    const subscribe = () => {
      client
        .request({
          query: InvoiceCreatedDocument,
        })
        .subscribe({
          next(response) {
            if (!activeSale) return;

            const data = response.data as InvoiceCreatedSubscription;

            if (!data.invoiceCreated) return;

            queryClient.invalidateQueries({
              queryKey: useInvoicesQuery.getKey({ saleId: activeSale.id }),
            });
          },
        });
    };
    subscribe();
    return () => {
      client.close();
    };
  }, [queryClient, activeSale]);
};
